import type { PrintJob } from '../types';

export interface JobOrderSummary {
  orderId?: number | string;
  customerDisplayName: string;
}

const normalize = (value?: string) => value?.trim() ?? '';

export const getJobOrderSummary = (job: PrintJob): JobOrderSummary => {
  const partOrder = job.metadata.originalPartOrder;
  const orderId = partOrder.order?.id ?? partOrder.id ?? job.partOrderId;
  const safeFirstname = normalize(partOrder.orderInfo?.firstname);
  const safeLastname = normalize(partOrder.orderInfo?.lastname);

  const customerInitial = safeFirstname
    ? `${safeFirstname.charAt(0).toUpperCase()}.`
    : '';
  const formattedLastName = safeLastname
    ? `${safeLastname.charAt(0).toUpperCase()}${safeLastname
        .slice(1)
        .toLowerCase()}`
    : '';

  const customerDisplayName = [customerInitial, formattedLastName]
    .filter(Boolean)
    .join(customerInitial ? ' ' : '');

  return {
    orderId,
    customerDisplayName,
  };
};
